import React, { Component } from 'react';
import ModalOverlay from "../../../../../components/UI/ModalOverlay";
import theme from '../../../../../Theme/theme';
import Button from '../../../../../components/UI/Button';
import SlideSwitch from "../../../../../components/SlideSwitch";

import axios from "axios";
import { toast } from "react-toastify";
import { API_URL } from "config/constants";

const TITLE = "Edit Force Update";
const DONE_TEXT = "SAVE";
const CLOSE_TEXT = "CLOSE"
const ANDROID_VERSION = "Android Version";
const IOS_VERSION = "iOS Version";
const FORCE_UPDATE = "Force Update";

export default class EditModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            android_version: props.data.android_version,
            ios_version: props.data.ios_version,
            isForceUpdate: props.data.isForceUpdate
        }
    }

    render() {
        return (
            <ModalOverlay
                modalStyle={style.modalStyle}
                header={TITLE}
                headerStyle={style.headerStyle}
                headerBodyStyle={style.headerBodyStyle}
                bodyStyle={style.modalBody}
                underLayerStyle={style.underLayer}
                close={this.props.close}>
                <div style={style.selectorWrapper}>
                    <p style={style.selectorLabel}>{ANDROID_VERSION} &nbsp; &nbsp;</p>
                    <input
                        value={this.state.android_version}
                        style={{ ...style.input, ...{ backgroundColor: theme.color.textLightWhite }, ...{ border: this.isValidNumber(this.state.android_version) ? "1px solid #444445" : "1px solid #ff0000" } }}
                        onChange={e => {
                            this.setState({
                                android_version: e.target.value
                            });
                        }}
                    />
                </div>
                <div style={style.selectorWrapper}>
                    <p style={style.selectorLabel}>{IOS_VERSION} &nbsp; &nbsp;</p>
                    <input
                        value={this.state.ios_version}
                        style={{ ...style.input, ...{ backgroundColor: theme.color.textLightWhite }, ...{ border: this.isValidNumber(this.state.ios_version) ? "1px solid #444445" : "1px solid #ff0000" } }}
                        onChange={e => {
                            this.setState({
                                ios_version: e.target.value
                            });
                        }}
                    />
                </div>
                <div style={style.selectorWrapper}>
                    <p style={style.selectorLabel}>{FORCE_UPDATE} &nbsp; &nbsp;</p>
                    <SlideSwitch
                        style={style.sliderStyle}
                        checked={this.state.isForceUpdate}
                        onClick={() => {
                            this.setState({ isForceUpdate: !this.state.isForceUpdate })
                        }} />
                </div>
                <div style={style.doneButtonWrapper}>
                    <Button
                        style={style.doneButton}
                        type="primary"
                        onClick={this.save}>
                        {DONE_TEXT}
                    </Button>
                    <Button
                        style={style.closeButton}
                        type="primary"
                        onClick={this.props.close}>
                        {CLOSE_TEXT}
                    </Button>
                </div>
            </ModalOverlay>
        )
    }

    isValidNumber(value) {
        try {
            return Number.isInteger(parseInt(value))
        } catch (e) {
            return false;
        }
    }

    save = () => {
        if (this.isValidNumber(this.state.android_version) && this.isValidNumber(this.state.ios_version)) {
            let toastId = toast("Updating versions...")
            this.setState({
                android_version: parseInt(this.state.android_version),
                ios_version: parseInt(this.state.ios_version),
            }, () => {
                axios.put(
                    `${API_URL}/version`,
                    this.state,
                    {
                        headers: {
                            "x-access-token": localStorage.getItem("access_token")
                        }
                    }).then(() => {
                        toast.dismiss(toastId);
                        toastId = toast("Updated successfully");
                        setTimeout(() => {
                            this.props.close();
                            toast.dismiss(toastId);
                        }, 1000)
                    }).catch((e) => {
                        toast.dismiss(toastId);
                        let message = e.message;
                        if (e.response && e.response.data && e.response.data.message) {
                            message = e.response.data.message
                        }
                        toastId = toast(message);
                        setTimeout(() => {
                            toast.dismiss(toastId);
                        }, 2000)
                    })
            })
        } else {
            let toastId = toast('Please enter valid versions.');
            setTimeout(() => {
                toast.dismiss(toastId);
            }, 2000)
        }
    }
}

const style = {
    modalStyle: {
        backgroundColor: theme.color.white,
        borderRadius: 3
    },
    underLayer: {
        backgroundColor: theme.color.shadowColor
    },
    headerStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        backgroundColor: theme.color.transparent
    },
    headerBodyStyle: {
        width: "100%",
        height: 40,
        fontSize: 25,
        letterSpacing: 0,
        borderRadius: 3,
        lineHeight: "40px",
        fontFamily: theme.font.avenirBlackOblique,
        color: theme.color.thickGrey,
    },
    modalBody: {
        margin: 25,
        marginTop: 0,
        borderRadius: "0px 0px 15px 15px",
        backgroundColor: theme.color.transparent
    },
    doneButtonWrapper: {
        width: "400",
        display: "flex",
        justifyContent: "space-around",
        marginTop: 20
    },
    doneButton: {
        width: "160px",
        fontSize: "20px"
    },
    closeButton: {
        width: "160px",
        fontSize: "20px",
        marginLeft: "20px"
    },
    selectorWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "nowrap",
        height: 70
    },
    selectorLabel: {
        fontSize: "22px",
        color: "#444445",
        marginRight: "15px",
        width: "150px",
        textAlign: "left",
        height: 20
    },
    input: {
        border: "1px solid #444445",
        borderRadius: 50,
        fontSize: 18,
        color: theme.color.primaryBlue,
        padding: 10,
        paddingLeft: 20,
        minWidth: 200,
        textAlign: "left",
        backgroundColor: theme.color.textLightWhite
    },
    sliderStyle: {
        justifyContent: 'flexit-start',
        flex: 1,
        minWidth: 75
    },
}